import config from "config";
import ButtonLoader from "Home/CommonResources/ButtonLoader/ButtonLoader";
import HomeApiCall from "HomeApiCall";
import React, { Component } from "react";
import './EmployeesOnLeave.css';

export class EmployeesOnLeave extends Component {
	constructor(props) {
        super(props);
        this.state = {
            fetchingData: false,
            absentEmployeesData: {}
        };
    }
    
    componentDidMount() {
        // METHOD CALLED TO GET LECTURE DETAILS
        this.apiCallToGetAbsentEmployees();
    }

    formatDate = () => {
        var d = new Date(),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
    
        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;
    
        return [year, month, day].join('-');
    }

    // API CALL METHOD TO GET LECTURE DETAILS
    apiCallToGetAbsentEmployees = async () => {
        this.setState({
            fetchingData: true
        });

        let requestData = {
            institute_id: config.institute_id,
        };
        

        let jsonResponse = await HomeApiCall.makeApiCall(
            'getAbsentEmployeesList',
            requestData,
            '/api/leaveManagement/dashboard.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetAbsentEmployees();
            }, 1000);
        }else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                
                this.setState({
                    absentEmployeesData: apiResult,
                    fetchingData: false
                });
            }
        }
    }

    render() {
        return (
            <div className="sessionDetails">
                <a href={`${config.RootUrl}/modules/leavemanagement/#/`}>
                    <p style={{ fontSize: 15, fontWeight: 'bold', color: '#2979FF' }}>Employees on Leave today</p>
                </a>
                <div className="py-2 scrollable">
                    {
                        this.state.fetchingData 
                        ?   <ButtonLoader/>
                        :
                        Object.keys(this.state.absentEmployeesData).length > 0 
                        ?
                            Object.keys(this.state.absentEmployeesData).map(leaveId => {
                                let leave = this.state.absentEmployeesData[leaveId];
                                return(
                                    <>
                                        <div className="d-flex w-100 flex-column border-bottom">
                                            <div className="d-flex justify-content-sm-betwee align-items-center">
                                                <span className="absentEmployeeName">
                                                    {leave.facultyName}
                                                </span>
                                                &nbsp;
                                                <span style={{ color:'gray', fontSize:'12px' }}>
                                                    ({leave.facultyDesignation})
                                                </span>
                                            </div>
                                            <div className="py-1 d-flex justify-content-sm-between align-items-center">
                                                <p style={{ fontSize:'12px' }}>
                                                    {leave.LeaveDayType == "fullday" ? "Full Day" : leave.LeaveDayType == "shortleave" ? "Short Leave" : "Half Day"}
                                                    <span style={{ marginLeft: 10 }}>
                                                        {leave.LeaveDayType == "halfday-1" ? "First Half" : (leave.LeaveDayType == "halfday-2" ? "Second Half" : "")}
                                                    </span>
                                                </p>
                                                <div style={{ color:'gray', fontSize:'12px' }}>
                                                    {leave.readableFromDate+" - "+leave.readableToDate}
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )
                            })
                        :   <p style={{ fontSize: 12, color: '#818181' }}>No employee is on leave today.</p>
                    }
                </div>
            </div>
        );
    }
}

export default EmployeesOnLeave;
